var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-testid":_vm.getTestId('admin-users-page')}},[_c('UserCrudTable',{attrs:{"data-testid":_vm.getTestId('admin-users-table')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }